"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactMarkdown = _interopRequireDefault(require("react-markdown"));

var _Link = _interopRequireDefault(require("../../navigation/Link/Link"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Markdown = ({
  children,
  components,
  removeWrapper,
  ...otherProps
}) => {
  components = components || {
    a: ({
      node,
      ...props
    }) => {
      const {
        href,
        ...linkProps
      } = props;
      return href.indexOf("https://") === 0 || href.indexOf("http://") === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
        href: href,
        ...linkProps,
        target: "_blank",
        children: node.children[0].value
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
        to: href,
        ...linkProps,
        children: node.children[0].value
      });
    }
  };

  if (removeWrapper) {
    components.p = _react.default.Fragment;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactMarkdown.default, {
    components: components,
    ...otherProps,
    children: children
  });
};

Markdown.propTypes = {
  children: _propTypes.default.node
};
Markdown.displayName = 'Markdown';
var _default = Markdown;
exports.default = _default;